import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StartComponent } from '../start/start.component';



const routes: Routes = [
  { path: 'start', component: StartComponent},
  { path: 'digi/connect', loadChildren: 'app/digi/digi.module#DigiModule'},
  { path: 'remote/settings', loadChildren: 'app/remote/remote.module#RemoteModule'},
  { path: '',
    redirectTo: '/start',
    pathMatch: 'full'
  },
  { path: '**', redirectTo: '/start' }
];

export const AppRoutingModule: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./src/app/app-routing/app-routing.module.ts